export const GET_DENOMINATION_REQUEST = "GET_DENOMINATION_REQUEST"
export const GET_DENOMINATION_SUCCESS = "GET_DENOMINATION_SUCCESS"
export const GET_DENOMINATION_FAILURE = "GET_DENOMINATION_FAILURE"